export default "__VITE_ASSET__2bbb5dc8__"